module.exports = __webpack_public_path__ + "static/media/dashboard-setting-image2.3a8f5460.png";